import React from "react";
import Helmet from "react-helmet";
import { Link } from 'react-router-dom';
import H2 from "@material-tailwind/react/Heading2";
import LeadText from '@material-tailwind/react/LeadText';
import H5 from "@material-tailwind/react/Heading5";

import template1 from '../../assets/templatepaper/SNCS_ProceedingsPaper_LTP_ST_SN_Singapore.docx';

function Copyright() {
    return (
      <div className="container max-w-8xl relative mx-auto"> 
        <Helmet>
            <title>The 7th International Conference on Soft Computing in Data Science 2023 (SCDS2023) - Copyright</title>
            <meta name="description" content="The 7th International Conference on Soft Computing in Data Science (SCDS) 2023 that will be held from 24 - 25 January 2023" />
            <meta name="keywords" content="copyright, scds2023, scds 2023, uitm, aaec, shah alam, conference" />
        </Helmet>   
        <nav aria-label="breadcrumb" style={{ padding: '0.5rem'}}>
            <ol class="breadcrumb">
            <li class="breadcrumb-item"><Link to="/scds2023/home">Home</Link></li>
            <li class="breadcrumb-item active" aria-current="page">Copyright</li>
            </ol>
        </nav>

          <div className="items-center flex flex-wrap">
              <div className="w-full lg:w-6/12 px-2 ml-auto mr-auto text-center" >
                  <h1 color="dark">Copyright</h1>
                  <div style={{ textAlign:'justify', fontFamily: 'Verdana'}}>
                    <p color="dark-200" style={{ textAlign:'justify'}}>                      
                        Copyright: <a href={template1} target="blank"><u>Download the file.</u></a><br/>
                        {/* <p style={{ textAlign:'justify'}}>
                            <a href={template1}><u>Click here to download template</u></a><br/>                      
                        </p> */}
                    </p>              
                  </div>
                  
              </div>
          </div>

  </div>
    );
}

export default Copyright;;